import { Component, Input } from '@angular/core';
import { RecipientView } from 'app/main/shared/shared/table/models/recipient-view.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-multiple-items-with-tooltip',
    templateUrl: './multiple-items-with-tooltip.component.html',
    styleUrl: './multiple-items-with-tooltip.component.scss'
})
export class MultipleItemsWithTooltipComponent {

    firstItem: RecipientView | null = null;
    tooltipItems: RecipientView[] = [];
    tooltipText = '';

    constructor(
        private _translocoService: TranslocoService
    ) { }

    @Input() set items(items: RecipientView[]) {
        this.firstItem = items?.[0] ?? null;
        this.tooltipItems = items?.slice(1) ?? [];

        this.tooltipText = this.tooltipItems
            .map(i => i.isDeleted ? `${i.name} (${this._translocoService.translate("Deleted status label (general) - Deleted")})` : i.name)
            .join(', ');
    }
}
